import { SxStyles } from '../../types';
import { getResponsiveSize } from '../../utils';

const mediaBorderRadius = getResponsiveSize(12);

export const PractitionerMediaPreviewPlayerStyle: SxStyles = {
  PractitionerMediaPreviewPlayerPsylarisLibrary: {
    position: 'absolute',
    zIndex: 5,
    width: '100%',
    height: '80%',
    '&.practitioner-preview': {
      zIndex: 0,
    },
    '& .player-container': {
      position: 'absolute',
      zIndex: 5,
      height: 'auto',
      minHeight: '360px',
      width: '100%',
      right: 5,
      top: 0,
      padding: '1em',
      maxWidth: '50%',
      display: 'flex',
      justifyContent: 'flex-end',
      '& .player-overlay': {
        position: 'absolute',
        top: 10,
        left: 0,
        bottom: 0,
        right: 10,
        borderRadius: mediaBorderRadius,
        overflow: 'hidden',
      },
      '& .react-player': {
        minHeight: '360px',
        height: '100%',
        borderRadius: mediaBorderRadius,
        overflow: 'hidden',
      },
    },
    ' .player-container-image': {
      position: 'absolute',
      zIndex: 5,
      width: '100%',
      right: 5,
      top: 0,
      padding: '1em',
      display: 'flex',
      justifyContent: 'flex-end',
      '& .player-overlay': {
        position: 'absolute',
        top: 10,
        left: 0,
        bottom: 0,
        right: 10,
      },
      '& .player-overlay-image': {
        position: 'relative',
        width: '50%',
        display: 'flex',
        height: '100%',
        borderRadius: mediaBorderRadius,
        overflow: 'hidden',
        '&::before': {
          content: '""',
          display: 'block',
          paddingTop: '56.25%',
        },
        // Img is the visible photo itself (natural size, scaled to fit, centred) — not
        // a full-bleed object-fit:contain box — so border-radius rounds the real photo
        // instead of the transparent letterbox around it. `inset: 0 + margin: auto`
        // centres it for any aspect ratio.
        '& img': {
          position: 'absolute',
          inset: 0,
          margin: 'auto',
          maxWidth: '100%',
          maxHeight: '100%',
          width: 'auto',
          height: 'auto',
          borderRadius: mediaBorderRadius,
        },
      },
    },
  },
};
